import {AnyAction} from 'redux';

import {showNotification} from 'app/toasts/slice';
import {VIDEO_API} from 'app/urls';
import {generateEmbedlyOembed} from 'app/utils/embedly';
import {gt} from 'app/utils/i18n';
import {createErrorHandler, get, serialize} from 'app/utils/request';

import {VideoSerializedType} from 'sweet-types';

import type {AppDispatchType} from 'app/store/AppStore';

export const REQUEST_VIDEO_DETAILS = 'REQUEST_VIDEO_DETAILS';
export const RECEIVE_VIDEO_DETAILS = 'RECEIVE_VIDEO_DETAILS';

const getFetchErrorMsg = () => gt('There was an error fetching a video');

/* sync actions */

export const requestVideoDetails = (hashid: string): AnyAction => ({
  type: REQUEST_VIDEO_DETAILS,
  hashid,
});

export const receiveVideoDetails = (video: VideoSerializedType): AnyAction => ({
  type: RECEIVE_VIDEO_DETAILS,
  video,
});

export const fetchVideoDetails =
  (hashid: string) =>
  (dispatch: AppDispatchType): Promise<unknown> => {
    dispatch(requestVideoDetails(hashid));
    return get(`${VIDEO_API}${hashid}/`)
      .then((data: VideoSerializedType) => dispatch(receiveVideoDetails(data)))
      .catch(
        createErrorHandler(getFetchErrorMsg(), dispatch, {
          '403': () => {
            const dummyVideo = {
              hashid,
              id: -1,
              url: '',
              original_url: '',
              html: '',
              src_url: '',
              video_url: '',
              object_id: -1,
              content_type: 'procedureversion' as const,
            };
            dispatch(receiveVideoDetails(dummyVideo));
            return dispatch(
              showNotification(gt('Embedded video not found'), 'warning')
            );
          },
        })
      );
  };

export const RECEIVE_MEDIA_OEMBED = 'RECEIVE_MEDIA_OEMBED';

export const receiveMediaOembed = (
  url: string,
  oembed: unknown
): AnyAction => ({
  type: RECEIVE_MEDIA_OEMBED,
  url,
  oembed,
});

export const getMediaOembed =
  (EMBEDLY_KEY?: string) =>
  (opts: {url: string; [key: string]: number | string}) =>
  (dispatch: AppDispatchType): void => {
    const {url, ...other} = opts;
    if (EMBEDLY_KEY != null) {
      generateEmbedlyOembed(url, EMBEDLY_KEY, other).then((oembed) =>
        dispatch(receiveMediaOembed(serialize(opts), oembed))
      );
    }
  };
